<form *ngIf="formPesquisa" class="d-flex align-items-center filtros-header" [formGroup]="formPesquisa">
  <mat-form-field>
    <mat-label>Data Inclusão de:</mat-label>
    <input matInput autocomplete="off" maskDate [matDatepicker]="dataInicio" formControlName="dataInicio" />
    <mat-datepicker-toggle matSuffix [for]="dataInicio"></mat-datepicker-toggle>
    <mat-datepicker #dataInicio></mat-datepicker>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Até:</mat-label>
    <input matInput autocomplete="off" maskDate [matDatepicker]="dataFim" formControlName="dataFim" />
    <mat-datepicker-toggle matSuffix [for]="dataFim"></mat-datepicker-toggle>
    <mat-datepicker #dataFim></mat-datepicker>
  </mat-form-field>

  <mat-form-field>
    <mat-select formControlName="clienteId" disableOptionCentering="true" placeholder="Cliente">
      <mat-option><ngx-mat-select-search [formControl]="clienteMultiFilter" placeholderLabel="Buscar..."
          noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
      <mat-option value="">Todos</mat-option>
      <mat-option *ngFor="let cliente of filteredClientes | async" [value]="cliente?.id">
        {{ cliente?.nome }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-label>Número do Lote</mat-label>
    <input matInput placeholder="Número do Lote" formControlName="numeroLote" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Número CT-e</mat-label>
    <input matInput placeholder="Número CT-e" formControlName="numeroCte" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Chave CT-e</mat-label>
    <input matInput placeholder="Chave CT-e" formControlName="chaveCte" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>NRT/Código do Volume/Ducumento</mat-label>
    <input matInput placeholder="NRT/Código do Volume/Ducumento" formControlName="codBarras" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>Usuário</mat-label>
    <input matInput placeholder="Usuário" formControlName="usuario" />
  </mat-form-field>

  <mat-form-field>
    <mat-select formControlName="statusLote" disableOptionCentering="true" placeholder="Status do Lote">
      <mat-option><ngx-mat-select-search [formControl]="statusMultiFilter" placeholderLabel="Buscar..."
          noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
      <mat-option value="">Todos</mat-option>
      <mat-option *ngFor="let status of filteredStatus | async" [value]="status?.statusId">
        {{ status?.statusDesc }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-select formControlName="acoes" disableOptionCentering="true" placeholder="Ações">
      <mat-option><ngx-mat-select-search [formControl]="acoesMultiFilter" placeholderLabel="Buscar..."
          noEntriesFoundLabel="Nenhum resultado encontrado..."></ngx-mat-select-search></mat-option>
      <mat-option value="">Todos</mat-option>
      <mat-option *ngFor="let acoes of filteredAcoes | async" [value]="acoes?.id">
        {{ acoes?.descricao }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button mat-icon-button (click)="limparCampos()" matTooltip="Limpar Campos">
    <i class="fas fa-eraser eraser-button"></i>
  </button>
  <button mat-icon-button (click)="trigger()" [disabled]="!validar() || formPesquisa.invalid">
    <i class="fas fa-search search-button cursor-pointer-icon" matTooltip="Pesquisar"></i>
  </button>
</form>
